import { DoctorService } from '@/services/doctor.service.js';
export default {
  props: {
    rowData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showDialog: false,
      buttonDisabled: false,
      alert: {
        show: false,
        message: ''
      }
    };
  },
  methods: {
    async endReassignment() {
      if (this.buttonDisabled) {
        return;
      }
      this.buttonDisabled = true;
      try {
        if (!this.rowData.id) {
          this.alert = {
            show: true,
            message: 'This reassignment is no longer active. Refreshing patient details.'
          };
          this.$emit('refresh');
          return;
        }
        await DoctorService.cancelReassignment(this.rowData.id);
        this.$emit('show-toast', 'Temporary reassignment ended. Patient returned to the original doctor.');
        this.$emit('refresh');
        this.showDialog = false;
      } catch (e) {
        this.alert = {
          show: true,
          message: e.message
        };
      } finally {
        this.buttonDisabled = false;
      }
    },
    onHide() {
      this.alert = {
        show: false,
        message: ''
      };
      this.buttonDisabled = false;
    }
  }
};